import { Box, ErrorBoundary } from "@prismicio/editor-ui"
import { type ReactNode, Suspense } from "react"

import { useRepositoryMetaTitle } from "../../app/routing"
import { DocumentListHeader } from "../DocumentListHeader/DocumentListHeader"
import { DocumentListLayout } from "../documentListLayout"
import { DocumentListSidePanel } from "../DocumentListSidePanel"
import { DocumentListProvider } from "../useDocumentList"
import { MigrationReleasesListEmptyBody } from "./MigrationReleasesListEmptyBody"

export function MigrationReleasesList() {
  useRepositoryMetaTitle("Import")

  return (
    <DocumentListProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab={undefined} />}
        sidePanel={<DocumentListSidePanel selectedMenuItem="migration" />}
        body={
          <ErrorBoundary renderError={() => <p>error</p>}>
            <Suspense fallback={<p>loading</p>}>
              <MigrationReleasesListBody />
            </Suspense>
          </ErrorBoundary>
        }
      />
    </DocumentListProvider>
  )
}

interface MigrationReleasesListLayoutProps {
  children: ReactNode
}

export function MigrationReleasesListLayout(
  props: MigrationReleasesListLayoutProps
) {
  const { children } = props

  return (
    <Box
      flexDirection="column"
      gap={24}
      padding={{ left: 24, top: 24, bottom: 24 }}
      width="100%"
    >
      {children}
    </Box>
  )
}

function MigrationReleasesListBody() {
  // TODO: Get this over the internet otherwise, it will be a very boring screen
  const migrationReleases: unknown[] = []

  if (migrationReleases.length === 0) {
    return <MigrationReleasesListEmptyBody />
  }

  return (
    <MigrationReleasesListLayout>
      <MigrationReleasesListTable migrationReleases={migrationReleases} />
    </MigrationReleasesListLayout>
  )
}

interface MigrationReleasesListTableProps {
  migrationReleases: unknown[]
}

function MigrationReleasesListTable(props: MigrationReleasesListTableProps) {
  const { migrationReleases } = props

  return <>{/** Super table render here*/ migrationReleases}</>
}
